import {toast} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';

export const showToast = (message, type) => {
    type === 'success' ? toast.success(message, {position : 'top-center'}) : toast.error(message, {position : 'top-center'})
}